// Collapses/expands each primary-nav item's submenu on click, mobile only
// (desktop keeps the hover/focus-within flyout already handled in
// main.css). Only one submenu stays open at a time — opening another
// closes whichever was already open, like a standard accordion.
const MOBILE_QUERY = '(max-width: 960px)';

export function initNavSubmenus() {
  const items = document.querySelectorAll('.primary-nav__item');
  if (!items.length) return;

  items.forEach((item) => {
    const trigger = item.querySelector('a');
    const submenu = item.querySelector('.primary-nav__submenu');
    if (!trigger || !submenu) return;

    trigger.addEventListener('click', (event) => {
      if (!window.matchMedia(MOBILE_QUERY).matches) return;

      event.preventDefault();
      const isOpen = item.classList.contains('is-open');

      items.forEach((other) => other.classList.remove('is-open'));

      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });
}
